import React from "react";

export function useIsFirstRender(): boolean {
  const isFirst = React.useRef(true);

  if (isFirst.current) {
    // eslint-disable-next-line functional/immutable-data
    isFirst.current = false;

    return true;
  }

  return isFirst.current;
}
